import { render } from "./Center.vue?vue&type=template&id=de0957a6&ts=true"
import script from "./Center.vue?vue&type=script&lang=ts"
export * from "./Center.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__